/*
    创建者：shuxiaokai
    创建时间：2020-05-13 14:37
    模块名称：tooltip组件
    备注：xxxx
*/
<template>
    <div ref="tooltip" class="s-tooltip">
        <slot />
        <div v-show="isShow" ref="content" class="container">
            <div class="title">
                <div>{{ title }}</div>
                <div class="close el-icon-close" @click.stop="handleClose"></div>   
            </div>    
            <div class="content">
                <slot name="content" />
            </div>
            <div class="operation">
                <el-button size="mini" type="primary">确定</el-button>
                <el-button size="mini" @click.stop="handleClose">取消</el-button>
            </div>                    
        </div>            
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //=====================================content参数====================================//
            startLeft: 0, //左侧距离
            startTop: 0, //顶部距离
            contentWidth: 0, //内容宽度
            contentHeight: 0, //内容高度
            //=====================================其他参数====================================//
        };
    },
    watch: {
        isShow(val) {
            if (val) {
                setTimeout(() => {
                    this.initPosition();
                }, 1);
            }
        }
    },
    mounted() {
     
    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//
    
        //=====================================组件间交互====================================//  
        initPosition() {
            const defaultSlot = this.$slots.default[0].elm;
            const contentSlot = this.$slots.content[0].elm;
            const tooltip = this.$refs["tooltip"];
            const content = this.$refs["content"];

            const defaultSlotWidth = defaultSlot.getBoundingClientRect()["width"];
            const defaultSlotHeight = defaultSlot.getBoundingClientRect()["height"];
            this.startLeft = tooltip.getBoundingClientRect()["left"];
            this.startTop = tooltip.getBoundingClientRect()["top"];
            this.contentWidth = contentSlot.getBoundingClientRect()["width"];
            this.contentHeight = contentSlot.getBoundingClientRect()["height"];

            content.style.left = this.startLeft - this.contentWidth + defaultSlotWidth + "px";
            content.style.top = this.startTop + defaultSlotHeight + "px";
            content.style.width = this.contentWidth + "px";
            content.style.height = this.contentHeight + 90 + "px";
        },
        //=====================================其他操作=====================================//
        handleClose() {
            this.$emit("close");
            this.$emit("update:isShow", false);
        }
    }
};
</script>



<style lang="scss">
.s-tooltip {
    .container {
        position: fixed;
        background: $white;
        box-shadow: $box-shadow;
        border-radius: $border-radius-base;
        z-index: 20;
        left: 0;
        top: 0;
        width: size(0);
        height: size(0);
        .title {
            text-indent: fz(10);
            display: flex;
            align-items: center;
            height: size(40);
            position: relative;
            border-bottom: 1px solid $gray-400;
            .close {
                color: $gray-800;
                font-size: fz(18);
                position: absolute;
                right: size(10);
                top: size(10);
                &:hover {
                    cursor: pointer;
                    color: $red;
                }
            }            
        }
        .operation {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: size(50);
            padding: 0 size(10);
            position: absolute;
        }           
    }
     
}
</style>
